import React from 'react';

import * as S from './styled';

const Input = ({ label, defaultValue, ...props }) => {
  return <S.CustomInput label={label} defaultValue={defaultValue} {...props} />;
};

export default Input;
